<template>
  <div
    v-if="loading"
    id="page"
    class="flex flex-col items-center justify-center min-h-screen w-full"
  >
    <div
      class="spinner mx-auto"
      style="border: 3px solid rgb(141 183 227 / 30%);border-top-color: #80b1fc;"
    ></div>
    <div class="p-4" style="color: rgb(78 143 243);">
      Loading, please wait...
    </div>
  </div>
  <div v-else>
    <Navbar
      id="header"
      class="bg-white border-b border-solid border-gray-200 opacity-100 py-2 px-10 shadow"
    >
      <template v-slot:left>
        <div id="name" class="flex flex-row">
          <router-link
            :to="{ name: 'survey-list' }"
            class="px-4 text-lg font-bold border border-transparent cursor-pointer rounded text-purple-600 hover:no-underline"
            >AppFlowz
          </router-link>
        </div>
      </template>
    </Navbar>

    <div class="mx-10 mt-5">
    
    <router-link
        :to="{ path: '/surveys/list' }"
        class="px-4 font-normal align-middle text-sm border border-transparent cursor-pointer rounded text-gray-400 hover:no-underline hover:text-purple-400"
      >
        <svg-icon
          icon="heroicons/outline/arrow-left"
          class="h-4 w-4 inline-block align-middle"
        ></svg-icon>
        Back to surveys
      </router-link>

      <div class="rounded-lg shadow-xl mt-10 px-10 pt-5 pb-10 bg-white">
          <h2 class="text-xl font-semibold"> Pixel Code </h2>
        <p class="pb-5">
          Copy the code below and place it before the closing &lt;/body&gt; tag
          on the page where you'd like your survey to be displayed:
        </p>
        <pre
          class="border border-solid border-gray-700"
        ><textarea style="overflow-x: auto; white-space: pre;width: 100%;min-height:200px;}" class="nohighlight" id="widget-code">
&lt;script type="text/javascript"&gt;
  (function (window, document) {
    uservoxSettings = {};
    var loader = function () {
      var e = document.createElement("script"),
        t = document.getElementsByTagName("script")[0];
      (e.src =
        ("https:" == document.location.protocol ? "https://" : "http://") +
        "userslice.com/script/loader.js?" +
        new Date().getTime()),
        t.parentNode.insertBefore(e, t);
    };
    window.addEventListener
      ? window.addEventListener("load", loader, !1)
      : window.attachEvent("onload", loader);
  })(window, document);
&lt;/script&gt;  

&lt;script type="text/javascript"&gt;
uservoxSettings = {
    survey_id: "f73b6bdb-55fa-44a7-8823-97eedf2fe40d", //your survey id
    user_email: "customer@example.com", //user email address
    user_name: "Sam Jones", //user's name (optional)
    container: document.currentScript,
};
&lt;/script&gt;
</textarea></pre>

        <h1>Install Instructions</h1>
        <p>
          We recommend installing the display pixel on the first page that is normally shown to the user after registering and logging in to your website, such as the main Dashboard page.
        </p>
        <p>Your Appflowz survey will be shown in a full screen overlay over the current page and will automatically close after user's complete the survey.</p>

      </div>

      <div class="rounded-lg shadow-xl px-10 pt-5 pb-10 bg-white">

      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Header.vue";
export default {
  data() {
    return {
      loading: false,
    };
  },
  components: { Navbar },
};
</script>

<style></style>
